import { Component, ComponentFactoryResolver, ElementRef, OnDestroy, Renderer2, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { ApiError, BaseVisualizacao, BaseVisualizacaoService, DataTablesService, MessageService, VisualizacaoStorageService } from '../../core';
import { UsuarioCrudHttpService } from './services';
import { ModalService } from '../../domains/shared/components/modal/services/modal.service';

import { AvatarComponent } from '../../domains/shared/components/avatar/avatar.component';
import { UsuarioAlteraSenhaModalComponent } from './altera-senha-modal';
import { UsuarioFilter, UsuarioFilterCollapseComponent } from './filter';
import { UsuarioPerfilPipe } from './pipes';
import { Usuario } from './usuario';
import { usuarioAtivo, usuarioInativo } from './usuario-situacao';
import { FormInativarUsuarioModal } from './modals/form-inativar/form-inativar-usuario.modal';
import { FormReativarUsuarioModal } from './modals/form-reativar/form-reativar-usuario.modal';

@Component({
    selector: 'sgt-usuario',
    templateUrl: './usuario.component.html',
    styleUrls: ['./usuario.component.less']
})
export class UsuarioComponent implements BaseVisualizacao<Usuario>, OnDestroy {
    entities: Usuario[];
    dataTable: any;
    idDataTable = 'tableUsuarios';

    filter = new UsuarioFilter();
    orderBy: number;
    orderByDir: string;
    @ViewChild('filterCollapse') filterCollapse: UsuarioFilterCollapseComponent;
    @ViewChild('containerTable') containerTable: ElementRef;

    /** Container para criar dinamicamente os avatares dos usuários */
    @ViewChild('avatarContainer', {read: ViewContainerRef}) avatarContainer: ViewContainerRef;

    @ViewChild('usuarioAlteraSenhaModal') usuarioAlteraSenhaModal: UsuarioAlteraSenhaModalComponent;

    constructor(private activatedRoute: ActivatedRoute,
                private router: Router,
                private componentFactoryResolver: ComponentFactoryResolver,
                private renderer: Renderer2,
                private messageService: MessageService,
                private dataTablesService: DataTablesService,
                private baseVisualizacaoService: BaseVisualizacaoService,
                private usuarioCrudHttpService: UsuarioCrudHttpService,
                private visualizacaoStorageService: VisualizacaoStorageService,
                private modalService: ModalService,
                private usuarioPerfilPipe: UsuarioPerfilPipe) { }

    /** Pesquisando após iniciar o filtro */
    onFilterInitialized() {
         // Aplicando o filtro armazenado no filtro avançado
         this.baseVisualizacaoService.aplicarFiltroArmazenado(this.filter, this.filterCollapse);

         // Obtendo os dados armazenados da visualização
         const vs = this.visualizacaoStorageService.get();
         // Criando a dataTable assíncrona
         // Se possuir dados armazenados, então aplicamos eles na dataTable
         if (vs != null) {
         this.createTable().then(() => {
                 this.dataTable.search(vs.filterSearch)
                                 .page(vs.currentPage)
                                 .order(vs.order)
                                 .draw(false);
                             });
         } else {
             this.filterCollapse.isFilterDirty = true;
             this.createTable()
                 .then(() => {})
                 .catch(() => {});
        }
    }

    search() {
        this.dataTable.ajax.reload();
     }

    private afterSearch() {
        // Setando o filtro, a página e a ordenação atual da tabela nos dados armazenados da visualização
        this.visualizacaoStorageService.set(this.filter, this.dataTable.search(), this.dataTable.page.info().page, this.dataTable.order());
    }

    private closeFilter() {
        this.filterCollapse.close();
        jQuery(this.containerTable.nativeElement).scrollTop(0);
    }

    clearFilter() {
        this.filterCollapse.clear()
        this.dataTable.search('');
    }

    showTable() { }

    /** Cria a Datatables assíncrona */
    createTable(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.dataTablesService.showTable(`#${this.idDataTable}`, this.dataTable, {
                serverSide: true,
                processing: true,
                order: [[1, 'asc']],
                pageLength: 10,
                columns: [
                    {
                        data: null,
                        className: 'col-options',
                        render: (data) => {
                            const entity = data as Usuario;

                            let options = `
                                <span class="btn-group dropup table-options">
                                    <button type="button" title="Opções" class="btn btn-link btn-options dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fas fa-ellipsis-h" aria-hidden="true"></i>
                                    </button>
                                    <div class="dropdown-menu">
                                        <a class="dropdown-item" id="edit">
                                            <i class="fas fa-pencil-alt" aria-hidden="true"></i> Editar
                                        </a>
                                        <a class="dropdown-item" id="openAlterarSenhaModal">
                                            <i class="fas fa-key" aria-hidden="true"></i> Alterar Senha
                                        </a>                                        
                                `

                                // Inativar
                                if (entity.situacao === usuarioAtivo.id) {
                                    options += `
                                            <div class="dropdown-divider"></div>
                                            <a class="dropdown-item dropdown-item-delete" id="inativar">
                                                <i class="fas fa-user-times" aria-hidden="true"></i> Inativar
                                            </a> 
                                    `
                                }

                                // Reativar
                                if (entity.situacao === usuarioInativo.id) {
                                    options += `
                                            <div class="dropdown-divider"></div>
                                            <a class="dropdown-item dropdown-item-success" id="reativar">
                                                <i class="fas fa-user-check" aria-hidden="true"></i> Reativar
                                            </a> 
                                    `
                                }

                                options += `
                                        <a class="dropdown-item dropdown-item-delete" id="delete">
                                            <i class="far fa-trash-alt" aria-hidden="true"></i> Excluir
                                        </a>                                
                                    </div>
                                </span>
                            `;

                            return options;
                        },
                        createdCell: (td, cellData, rowData, row, col) => {
                            const dropdown = jQuery(td).find('.btn-group');
                            // Ao abrir o dropdown, adicionamos ele no body para exibi-lo corretamente na table
                            dropdown.on('show.bs.dropdown', function() {
                                jQuery('body').append(dropdown.css({
                                        position: 'absolute',
                                        left: dropdown.offset().left,
                                        top: dropdown.offset().top
                                    }).detach());
                            });
                            // Ai fechar o dropdown, adicionamos ele novamente a coluna das opções na table
                            dropdown.on('hidden.bs.dropdown', function() {
                                jQuery(td).append(dropdown.css({
                                    position: 'relative',
                                    left: 'auto',
                                    top: 'auto'
                                }).detach());
                            });

                            // Vinculando os eventos de click das opções da tabela
                            const myself = this;
                            // Opções do dropdown
                            dropdown.on('click', 'a', function() {
                                if (this.id === 'edit') { // Edit
                                    myself.edit(cellData);
                                } else if (this.id === 'delete') { // Delete
                                    myself.delete(cellData);
                                } else if (this.id === 'openAlterarSenhaModal') { // Alterar senha
                                    myself.openAlterarSenhaModal(cellData);
                                } else if (this.id === 'inativar') { // Inativar
                                    myself.openInativarUsuarioModal(cellData);
                                } else if (this.id === 'reativar') { // Reativar
                                    myself.openReativarUsuarioModal(cellData);
                                }
                            });
                        }
                    },
                    {
                        data: null,
                        className: 'col-usuario',
                        render: (data: Usuario) => `
                                <div class="d-flex align-items-center">
                                    <div class="col-usuario-avatar"></div>
                                    <div class="ml-2">
                                        <h6 class="col-usuario-nome">${data?.nome}</h6>
                                        <small class="col-usuario-login">${data?.login}</small>
                                    </div>
                                </div>
                            `,
                        createdCell: (td: any, cellData: any, data: Usuario) => {
                            if (data) {
                                // Criando o avatar
                                const avatarFactory = this.componentFactoryResolver.resolveComponentFactory(AvatarComponent);
                                const avatarRef = this.avatarContainer.createComponent(avatarFactory);
                                avatarRef.instance.settings.fullName = data.nome;
                                avatarRef.instance.settings.imageUrl = data.avatarUrl;
                                avatarRef.instance.settings.size = 42;
                                // Inserindo o avatar na table cell
                                this.renderer.appendChild(jQuery(td).find('.col-usuario-avatar')[0], avatarRef.location.nativeElement);

                                // Adicionando atributo title a coluna
                                td.title = `${data?.nome} - ${data?.login}`;
                            }
                        }
                    },
                    {data: 'perfil', className: 'col-perfil text-center', render: (data) => this.usuarioPerfilPipe.transform(data)},
                    {
                        data: 'situacao',
                        className: 'col-situacao text-center',
                        render: (data) => {
                            switch (data) {
                                case 1:
                                    return '<span class="badge badge-success">Ativo</span>';
                                case 2:
                                    return '<span class="badge badge-danger">Inativo</span>';
                                default:
                                    return '';
                            }
                        }
                    }
                ],
                ajax: (data, callback, settings) => { // Evento Ajax para pesquisar as tabelas de preços
                    this.closeFilter();

                    const order = data.order[0];
                    this.filter.filterPsq = data.search.value;
                    this.orderBy = order.column;
                    this.orderByDir = order.dir;
                    this.usuarioCrudHttpService.searchWithFilter(this.filter, data.draw, data.start, data.length, order.column, order.dir)
                        .subscribe(
                            response => {
                                this.entities = response.data;
                                this.afterSearch();
                                callback(response);
                            },
                            (error: ApiError) => {
                                this.messageService.error(error.message, 'Erro ao pesquisar os usuários', error);
                                this.afterSearch();
                                callback({recordsTotal: 0, recordsFiltered: 0, data: []});
                            }
                        );
                }
            })
            .then(dataTable => {
                this.dataTable = dataTable;
                setTimeout(() => resolve(), 500);
            });
        });
    }

    insert() {
        this.baseVisualizacaoService.insert(this.activatedRoute);
    }

    edit(entity: Usuario) {
        this.baseVisualizacaoService.edit(entity.id, this.activatedRoute);
    }

    delete(entity: Usuario) {
        this.messageService.confirm(`Deseja realmente excluir o usuário: ${entity.nome}?`)
            .then(result => {
                if (result) {
                    this.usuarioCrudHttpService.delete(entity.id)
                        .subscribe(
                            response => {
                                this.messageService.success('', response);
                                this.search();
                            },
                            (error: ApiError) => this.messageService.error(error.message, `Erro ao excluir o usuário: ${entity.nome}`, error)
                        )
                }
            });
    }

    /** Abre o modal para alterar a senha do usuário */
    openAlterarSenhaModal(entity: Usuario) {
        this.usuarioAlteraSenhaModal.open(entity.id, entity.nome);
    }

    /** Abre o modal para inativar o usuário */
    openInativarUsuarioModal(entity: Usuario) {
        if (!entity || !entity.id) {
            return;
        }
        const modalRef = this.modalService.open(FormInativarUsuarioModal);
        modalRef.instance.idUsuario = entity.id;
        modalRef.instance.confirmed.subscribe(() => {
            this.search();
        });
    }

    /** Abre o modal para reativar o usuário */
    openReativarUsuarioModal(entity: Usuario) {
        if (!entity || !entity.id) {
            return;
        }
        const modalRef = this.modalService.open(FormReativarUsuarioModal);
        modalRef.instance.idUsuario = entity.id;
        modalRef.instance.confirmed.subscribe(() => {
            this.search();
        });
    }

    /** Destroi todos os avatares criados dinamicamente e inseridos na table */
    private clearAvatars() {
        this.avatarContainer?.clear();
    }

    ngOnDestroy() {
        this.clearAvatars();
    }
}
